import {
    IS_LOADING,
    SET_FILTERED_AND_SORTED_NOTES,
    SET_EDITING_NOTE,
    SET_NOTES_FILTERS,
    SET_NOTES,
    SET_NB_ALL_NOTES,
} from "./siteMonitoringConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { adaptNoteForDb, adaptNoteForMyOpen, adaptNoteForOpenERP, adaptNoteFromOpenERP } from "./siteMonitoringCast";
import moment from "moment";
import { getBase64ImageWithHeader, guid } from "../../utils";
import db from "../../db";
import { ALL_SELECT_OPTION } from "../../constants";
import { clearComments, deleteComment, getComments, synchronizeComments } from "./commentActions";
import { siteMonitoringIsDisabled, userIsSiteMonitoringManager } from "./siteMonitoringActions";
import { addAnnotationToPlan, getPlanFromNote, updateAnnotationToPlan } from "./planActions";

export function siteMonitoringsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "site_monitoring_note",
        isLoading: value,
    };
}

export function setFilteredAndSortedNotesAction(filteredAndSortedNotes) {
    return {
        type: SET_FILTERED_AND_SORTED_NOTES,
        filteredAndSortedNotes,
    };
}

export function setEditingNoteAction(editingNote) {
    return {
        type: SET_EDITING_NOTE,
        editingNote,
    };
}

export function setNotesFiltersAction(filters) {
    return {
        type: SET_NOTES_FILTERS,
        filters: filters,
    };
}

export function setNotesAction(notes) {
    return {
        type: SET_NOTES,
        notes,
    };
}

function setNbNotesAssignedToMeAction(nb) {
    return {
        type: SET_NB_ALL_NOTES,
        nbAllNotes: nb,
    };
}

export function getNotes(siteMonitoring, filters, activeUser) {
    return (dispatch) => {
        dispatch(siteMonitoringsIsLoading(true));
        db.SiteMonitoringNote.filter((note) => {
            return note.affair_id === siteMonitoring.id;
        })
            .toArray()
            .then(async (notes) => {
                let transformedNotes = [];
                await Promise.all(
                    notes.map(async (n) => {
                        n.plan = await getPlanFromNote(siteMonitoring, n);
                        transformedNotes.push(adaptNoteForMyOpen(n));
                    })
                );

                dispatch(setNotesAction(transformedNotes));
                dispatch(applyFiltersAndSortNotes(filters, transformedNotes, activeUser.id));
            })
            .catch((err) => {
                console.error("Erreur : noteActions - getNotes", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des notes !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function updateNotesFilters(filters, allNotes, activeUser) {
    return (dispatch) => {
        dispatch(setNotesFiltersAction(filters));
        dispatch(applyFiltersAndSortNotes(filters, allNotes, activeUser));
    };
}

function applyFiltersAndSortNotes(notesFilters, notes, activeUser) {
    return (dispatch) => {
        let filteredNotes = filter(notesFilters, notes, activeUser);
        dispatch(setFilteredAndSortedNotes(filteredNotes));
        dispatch(siteMonitoringsIsLoading(false));
    };
}

export function setFilteredAndSortedNotes(filteredAndSortedNotes) {
    return (dispatch) => {
        dispatch(setFilteredAndSortedNotesAction(filteredAndSortedNotes));
    };
}

function filter(filters, notes, activeUser) {
    let filteredNotes = notes.sort(sortByDeadlineDateAndInProgressFirst).filter((note) => {
        return (
            filterByAssignedUser(filters, note) &&
            filterByCreateUser(filters, note) &&
            filterByLot(filters, note) &&
            filterByState(filters, note) &&
            filterByTags(filters, note) &&
            filterByLimitDate(filters, note) &&
            excludeDrawsFromAnotherUsers(note, activeUser.id)
        );
    });

    return filteredNotes;
}

function filterByAssignedUser(filters, note) {
    return filters.assignedUser
        ? filters.assignedUser === ALL_SELECT_OPTION || filters.assignedUser === note.assigned_user_id
        : true;
}

function filterByCreateUser(filters, note) {
    return filters.creatorId
        ? filters.creatorId === ALL_SELECT_OPTION || filters.creatorId === note.create_uid.id
        : true;
}

function filterByLot(filters, note) {
    return filters.lotId ? filters.lotId === ALL_SELECT_OPTION || filters.lotId === note.lot_id : true;
}

function filterByTags(filters, note) {
    //Parmis les tags sélectionnés dans les filtres, est-ce qu'il y en a un qui n'est pas dans la note
    if (filters.tags.some((t) => t === ALL_SELECT_OPTION)) return true;

    let tagOk = true;
    filters.tags.forEach((t) => {
        if (!note.category_ids.some((noteTag) => noteTag === t)) {
            tagOk = false;
            return;
        }
    });

    return tagOk;
}

function filterByLimitDate(filters, note) {
    return filters.limitDate ? filters.limitDate > note.date_deadline : true;
}

function filterByState(filters, note) {
    return filters.status && filters.status.length > 0
        ? (filters.status.some((status) => status === ALL_SELECT_OPTION) && note.state !== "closed") ||
              filters.status.some((status) => status === note.state)
        : true;
}

function excludeDrawsFromAnotherUsers(note, userId) {
    return !(note.state === "new" && note.create_uid.id !== userId);
}

function sortByDeadlineDateAndInProgressFirst(noteA, noteB) {
    if (noteA.state === "in_progress" && noteB.state !== "in_progress") return -1;
    if (noteA.state !== "in_progress" && noteB.state === "in_progress") return 1;

    if (moment(noteA.date_deadline).isBefore(moment(noteB.date_deadline))) return -1;

    if (moment(noteA.date_deadline).isAfter(moment(noteB.date_deadline))) return 1;

    return 0;
}

export function creatingNote(siteMonitoring, user, annotation = null) {
    return (dispatch) => {
        let newNote = {
            name: "",
            mobile_id: guid(),
            affair_id: siteMonitoring.id,
            lot_id: undefined,
            lot_mobile_id: undefined,
            description: "",
            date_deadline: moment(),
            assigned_user_id: undefined,
            state: "in_progress",
            category_ids: [],
            create_uid: user,
            create_date: moment(),
            creating: true,
            document_ids: [getDefaultPhoto()],
            annotation,
        };

        dispatch(setEditingNote(newNote));
    };
}

export function createNote(newNote, siteMonitoring, filters, user, alreadyExistsInDb = false) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let noteForOpenErp = adaptNoteForOpenERP(newNote);

        const body = {
            note: noteForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/notes/create", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                newNote.id = result.id;

                result.documents.forEach((serverDocument) => {
                    let clientDocument = newNote.document_ids.find((d) => d.guid && d.guid === serverDocument.guid);

                    if (clientDocument) clientDocument.id = serverDocument.id;
                });

                newNote.document_ids = newNote.document_ids.filter((d) => !d.deleted);

                if (alreadyExistsInDb) saveNoteInDb(newNote);
                else db.SiteMonitoringNote.add(adaptNoteForDb(newNote));

                if (newNote.annotation) {
                    newNote.annotation.data.text = newNote.name;
                    newNote.annotation.data.noteMobileId = newNote.mobile_id;
                    dispatch(
                        addAnnotationToPlan(siteMonitoring, newNote, user, () => {
                            if (filters) dispatch(getNotes(siteMonitoring, filters, user));
                        })
                    );
                }

                dispatch(clearEditingNote());

                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                let message = "Une erreur s'est produite lors de la création de la note.";
                if (err.noNetworkError) {
                    if (alreadyExistsInDb) saveNoteInDb(newNote);
                    else db.SiteMonitoringNote.add(adaptNoteForDb(newNote));

                    if (newNote.annotation) {
                        newNote.annotation.data.text = newNote.name;
                        newNote.annotation.data.noteMobileId = newNote.mobile_id;
                        dispatch(
                            addAnnotationToPlan(siteMonitoring, newNote, user, () => {
                                if (filters) dispatch(getNotes(siteMonitoring, filters, user));
                            })
                        );
                    }

                    dispatch(clearEditingNote());

                    if (filters) dispatch(getNotes(siteMonitoring, filters, user));

                    message +=
                        " Essayez de synchroniser la liste des chantiers afin d'être sûr que la note soit envoyée";
                }

                console.error("Erreur : noteActions - createNote: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message,
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function cancelNote(note, siteMonitoring, filters, user) {
    return (dispatch) => {
        note.deleted = true;
        note.state = "cancelled";
        dispatch(saveEditingNote(note, siteMonitoring, filters, user, true));
    };
}

export function terminateNote(note, siteMonitoring, filters, user) {
    return (dispatch) => {
        note.state = "done";
        dispatch(saveEditingNote(note, siteMonitoring, filters, user, true));
    };
}

export function confirmNote(note, siteMonitoring, filters, user) {
    return (dispatch) => {
        note.state = "in_progress";
        dispatch(saveEditingNote(note, siteMonitoring, filters, user, true));
    };
}

export function relaunchNote(note, siteMonitoring, filters, user) {
    return (dispatch) => {
        note.state = "in_progress";
        dispatch(saveEditingNote(note, siteMonitoring, filters, user, true, true));
    };
}

export function historizeNote(note, siteMonitoring, filters, user) {
    return (dispatch) => {
        note.state = "closed";
        dispatch(saveEditingNote(note, siteMonitoring, filters, user, true));
    };
}

export function saveNoteInDb(note) {
    db.SiteMonitoringNote.update(note.mobile_id, adaptNoteForDb(note));
}

export function saveEditingNote(
    note,
    siteMonitoring,
    filters,
    user,
    saveChangesOnError = false,
    keepOnThisNote = false
) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let noteForOpenErp = adaptNoteForOpenERP(note);

        const body = {
            note: noteForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/notes/save", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                result.documents.forEach((serverDocument) => {
                    let clientDocument = note.document_ids.find((d) => d.guid && d.guid === serverDocument.guid);

                    if (clientDocument) {
                        clientDocument.id = serverDocument.id;
                        clientDocument.creating = false;
                    }
                });

                note.document_ids = note.document_ids.filter((d) => !d.deleted);

                saveNoteInDb(note);

                dispatch(
                    updateAnnotationToPlan(siteMonitoring, note, user, () => {
                        if (filters) dispatch(getNotes(siteMonitoring, filters, user));
                    })
                );

                if (!keepOnThisNote) dispatch(clearEditingNote());

                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                let message = "Une erreur s'est produite lors de la sauvegarde de la note.";
                if (saveChangesOnError && err.noNetworkError) {
                    note.unsavedStatusUpdate = true;
                    saveNoteInDb(note);
                    if (!keepOnThisNote) dispatch(clearEditingNote());

                    if (filters) dispatch(getNotes(siteMonitoring, filters, user));

                    message +=
                        " Essayez de synchroniser la liste des chantiers afin d'être sûr que la note soit envoyée";
                } else if (err.noNetworkError)
                    message +=
                        " Vous pouvez utiliser la gallerie photo de votre périphérique afin d'ajouter des photos lorsque vous aurez récupérer une connexion stable";

                console.error("Erreur : noteActions - saveNote: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message,
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function clearEditingNote() {
    return (dispatch) => {
        dispatch(setEditingNote(null));
    };
}

export function setEditingNote(editingNote) {
    return (dispatch) => {
        dispatch(setEditingNoteAction(editingNote));
        if (!editingNote) dispatch(clearComments());
        else dispatch(getComments(editingNote));
    };
}

export function loadEditingNote(noteMobileId) {
    return (dispatch) => {
        db.SiteMonitoringNote.filter((note) => {
            return note.mobile_id === noteMobileId;
        })
            .toArray()
            .then((notes) => {
                if (notes.length > 0) {
                    let note = notes[0];
                    dispatch(setEditingNote(adaptNoteForMyOpen(note)));
                }
            })
            .catch((err) => {
                console.error("Erreur : noteActions - loadEditingNote", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de la note !",
                    })
                );
            });
    };
}

export async function countNotesAssignedToMe(siteMonitoring, userId) {
    return await db.SiteMonitoringNote.filter((note) => {
        return (
            note.affair_id === siteMonitoring.id &&
            ((note.state === "in_progress" && note.assigned_user_id === userId) ||
                (note.state === "new" && note.create_uid.id === userId))
        );
    })
        .toArray()
        .then((notes) => {
            return notes.length;
        })
        .catch((err) => {
            console.error("Erreur : noteActions - countNotesAssignedToMe", err);
        });
}

export function actualizeNumberNotesAssignedToMe(userId) {
    return (dispatch) => {
        db.SiteMonitoringNote.filter((note) => {
            return (
                (note.state === "in_progress" && note.assigned_user_id === userId) ||
                (note.state === "new" && note.create_uid.id === userId)
            );
        })
            .toArray()
            .then((notes) => {
                dispatch(setNbNotesAssignedToMeAction(notes.length));
            })
            .catch((err) => {
                console.error("Erreur : noteActions - countNotesAssignedToMe", err);
            });
    };
}

export function synchronizeNotes(serverLot, siteMonitoring, user) {
    return (dispatch) => {
        db.SiteMonitoringNote.filter((note) => {
            return note.lot_id === serverLot.id;
        })
            .toArray()
            .then((dbNotes) => {
                let dbNotesAlwaysInOpenErp = [];

                serverLot.action_ids.forEach((sn) => {
                    let transformedServerNote = adaptNoteFromOpenERP(sn);

                    let dbNote = dbNotes.find((dbn) => dbn.id === sn.id || dbn.mobile_id === sn.mobile_id);

                    dbNotesAlwaysInOpenErp = dispatch(
                        synchronizeNote(
                            dbNote,
                            transformedServerNote,
                            dbNotesAlwaysInOpenErp,
                            serverLot,
                            siteMonitoring,
                            user
                        )
                    );
                });

                dbNotes
                    .filter((dbn) => !dbNotesAlwaysInOpenErp.includes(dbn))
                    .forEach((dbn) => {
                        if (dbn.id) db.SiteMonitoringNote.delete(dbn.mobile_id);
                        else dispatch(createNote(adaptNoteForMyOpen(dbn), siteMonitoring, null, user, true));
                    });

                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : noteActions - synchronizeNotes", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la synchronisation des notes !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function deleteNote(note) {
    db.SiteMonitoringNote.delete(note.mobile_id);

    db.SiteMonitoringComment.filter((comment) => {
        return comment.note_id === note.id;
    })
        .toArray()
        .then((dbComments) => {
            dbComments.forEach((dbc) => {
                deleteComment(dbc);
            });
        });
}

export function synchronizeNote(dbNote, transformedServerNote, dbNotesAlwaysInOpenErp, lot, siteMonitoring, user) {
    return (dispatch) => {
        transformedServerNote.affair_id = lot.affair_id;

        let noteForDb = adaptNoteForDb(transformedServerNote);

        if (dbNote) {
            //Pour des raisons de performances, la récupération des pièces jointes est faite via une autre synchronisation (voir getDocumentsAttachment)
            //Puisque les documents ne sont pas modifiables, on ira chercher que les documents que nous n'avons pas encore sur le périphérique
            //Il faut donc garder le document sauvegardé dans indexeddb avant de le remplacer par le document du serveur
            noteForDb.document_ids.forEach((serverDocument) => {
                let dbDocument = dbNote.document_ids.find((dbDocument) => dbDocument.id === serverDocument.id);

                if (dbDocument) serverDocument.file_id = dbDocument.file_id;
            });
            dbNotesAlwaysInOpenErp.push(dbNote);
            if (dbNote.unsavedStatusUpdate) {
                transformedServerNote.state = dbNote.state;
                transformedServerNote.unsavedStatusUpdate = false;
                dispatch(saveEditingNote(transformedServerNote, siteMonitoring, null, user, true));
            }

            db.SiteMonitoringNote.update(transformedServerNote.mobile_id, noteForDb);
        } else {
            if (!noteForDb.mobile_id) {
                noteForDb.mobile_id = noteForDb.id;
            }
            db.SiteMonitoringNote.add(noteForDb);
        }

        dispatch(synchronizeComments(transformedServerNote, user));

        return dbNotesAlwaysInOpenErp;
    };
}

export function fillIdOfPhotoAndAddCreationPhoto(photos) {
    let photo = photos.find(function (element) {
        return !element.guid && !element.id;
    });

    photo.guid = guid();

    photos = addCreationPhotoIfNeeded(photos);
    return photos;
}

export function addCreationPhotoIfNeeded(currentPhotos) {
    let indexOfCreationLine = currentPhotos.find(function (element) {
        return !element.guid && !element.id;
    });

    if (!indexOfCreationLine) currentPhotos.push(getDefaultPhoto());

    return currentPhotos;
}

export function getDefaultPhoto() {
    return {
        guid: null,
        file_id: "",
        name: "",
        creating: true,
    };
}

export function checkIfDateDeadlineCanBeChange(siteMonitoring, note, activeUser) {
    if (note.creating) return true;

    return userIsSiteMonitoringManager(activeUser, siteMonitoring);
}

export function noteIsDisabled(siteMonitoring, note, activeUser) {
    if (note.creating) return false;

    let noteIsDone = note.state === "done";
    let noteIsClosed = note.state === "closed";
    let noteIsCancelled = note.state === "cancelled";

    let notMyDraftNote = note.state === "new" && note.create_uid && note.create_uid.id !== activeUser.id;

    let noteNotAssignedToMe =
        note.state === "in_progress" &&
        note.assigned_user_id !== activeUser.id &&
        !userIsSiteMonitoringManager(activeUser, siteMonitoring);

    return (
        siteMonitoringIsDisabled(siteMonitoring, activeUser) ||
        noteNotAssignedToMe ||
        notMyDraftNote ||
        noteIsDone ||
        noteIsClosed ||
        noteIsCancelled
    );
}

export function getDefaultNotesFilters() {
    return {
        lotId: ALL_SELECT_OPTION,
        assignedUser: ALL_SELECT_OPTION,
        tags: [ALL_SELECT_OPTION],
        creatorId: ALL_SELECT_OPTION,
        status: [ALL_SELECT_OPTION],
        limitDate: null,
    };
}

export function canCancelNote(editingNote, activeUser, siteMonitoring) {
    if (siteMonitoringIsDisabled(siteMonitoring, activeUser)) return false;

    if (editingNote.state === "new") return editingNote.create_uid.id === activeUser.id;

    if (editingNote.state === "in_progress")
        return userIsSiteMonitoringManager(activeUser, siteMonitoring) || editingNote.create_uid.id === activeUser.id;

    return false;
}

export function canTerminateNote(editingNote, siteMonitoring, activeUser) {
    if (siteMonitoringIsDisabled(siteMonitoring, activeUser)) return false;

    return (
        editingNote.state === "in_progress" &&
        (editingNote.assigned_user_id === activeUser.id || userIsSiteMonitoringManager(activeUser, siteMonitoring))
    );
}

export function canConfirmNote(editingNote, siteMonitoring, activeUser) {
    if (siteMonitoringIsDisabled(siteMonitoring, activeUser)) return false;

    return editingNote.state === "new" && editingNote.create_uid.id === activeUser.id;
}

export function canRelaunchNote(editingNote, siteMonitoring, activeUser) {
    let noteIsDone = editingNote.state === "done";

    return noteIsDone && userIsSiteMonitoringManager(activeUser, siteMonitoring);
}

export function canHistorizeNote(editingNote, siteMonitoring, activeUser) {
    return editingNote.state === "done" && userIsSiteMonitoringManager(activeUser, siteMonitoring);
}

export function getDocumentsAttachment(user) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            db.SiteMonitoringNote.toArray().then((dbNotes) => {
                let documentIdsToDownload = [];
                let notesToUpdate = [];

                dbNotes.forEach((n) => {
                    let documentsToDownload = n.document_ids.filter((d) => d.id && !d.file_id);

                    if (documentsToDownload.length > 0) notesToUpdate.push(n);

                    documentsToDownload.forEach((d) => {
                        documentIdsToDownload.push(d.id);
                    });
                });

                if (documentIdsToDownload.length <= 0) {
                    return resolve();
                }

                const headers = new Headers({ "Content-Type": "application/json" });
                fetchWithTimeout("/api/v1/siteMonitorings/get_documents_attachment", {
                    method: "POST",
                    headers: headers,
                    timeout: 60000,
                    body: JSON.stringify({
                        userId: user.id,
                        documentIdsToDownload,
                    }),
                })
                    .then((response) => {
                        if (!response.ok) throw Error(response.statusText);

                        return response;
                    })
                    .then((response) => response.json())
                    .then((serverDocuments) => {
                        notesToUpdate.forEach((n) => {
                            n.document_ids.forEach((dbDocument) => {
                                let serverDocument = serverDocuments.find((sd) => sd.id === dbDocument.id);
                                if (!serverDocument) return;

                                dbDocument.file_id = serverDocument.file_id
                                    ? getBase64ImageWithHeader(serverDocument.file_id)
                                    : "";
                            });

                            db.SiteMonitoringNote.update(n.mobile_id, {
                                document_ids: n.document_ids,
                            });
                        });

                        return resolve();
                    })
                    .catch((err) => {
                        console.error("Erreur : noteActions - getDocumentsAttachment", err);

                        dispatch(
                            throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors du téléchargement des documents !",
                            })
                        );

                        return reject();
                    });
            });
        });
    };
}
